import { ref, onMounted, onUnmounted } from 'vue'

export function useDarkMode() {
  const isDarkMode = ref(false)
  let mediaQuery = null

  const updateDarkMode = (e) => {
    isDarkMode.value = e.matches
  }

  onMounted(() => {
    // Check for system preference
    if (window.matchMedia) {
      mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
      isDarkMode.value = mediaQuery.matches
      mediaQuery.addEventListener('change', updateDarkMode)
    }
  })

  onUnmounted(() => {
    if (mediaQuery) {
      mediaQuery.removeEventListener('change', updateDarkMode)
    }
  })

  return {
    isDarkMode
  }
}